import { render, staticRenderFns } from "./VerDoctor.vue?vue&type=template&id=3c5f3ab6"
import script from "./VerDoctor.vue?vue&type=script&lang=js"
export * from "./VerDoctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports